<script setup lang="ts">
const heading = 'Trénink, adrenalin a regenerace pod jednou střechou';
// const paragraph = 'Poskládej si plán přesně pro tebe se slevou až 10%';
</script>

<template>
  <PageContainerAlignment
    class="gap-r6 flex flex-col justify-center text-white"
  >
    <AppHeading
      tag="h1"
      size="custom"
      class="text-5xl min-[1024px]:text-[4rem] min-[1920px]:text-7xl lg:w-1/2"
    >
      {{ heading }}
    </AppHeading>
    <!-- <AppParagraph> -->
    <!--   {{ paragraph }} -->
    <!-- </AppParagraph> -->
    <IndexHeaderOpeningHours />
  </PageContainerAlignment>
</template>
